import { hasSecretUrl } from "~/lib/secret-url";

/**
 * The connection hints for the tag manager and analytics hosts.
 *
 * They go with the analytics: a page whose URL is a credential (`SECRET_URL`)
 * names no tag manager or analytics host at all, in its scripts or its head.
 */
export function analyticsResourceHints(
  matches: Parameters<typeof hasSecretUrl>[0]
) {
  if (hasSecretUrl(matches)) {
    return [];
  }
  return [
    { href: "https://www.googletagmanager.com", rel: "preconnect" },
    { href: "https://www.googletagmanager.com", rel: "dns-prefetch" },
    // GA4 beacons only fire after analytics consent, so a lookup is as far as
    // it is worth warming — a preconnect would usually go unused.
    { href: "https://region1.google-analytics.com", rel: "dns-prefetch" },
  ];
}
